import gabonRoutes from "../router/routes";
const env = process.env.VUE_APP_ENV || "development";

const gaIds = {
  production: "G-D83B9ZHSJV",
  staging: "G-PGLFGH806X",
  development: "G-PGLFGH806X",
};
const trackingId = gaIds[env];

export default {
  platformId: "gabon_invest",
  mainLogo: "media/logos/gabon-logo.svg",
  lightLogo: "media/logos/gabon-logo-light.svg",
  sidebarLogo: "media/logos/gabon-logo-light.svg",
  dealSearchId: "gabon_invest",
  appTitle: "Gabon VDR",
  routes: gabonRoutes,
  customTheme: "gabon/styles/theme.scss",
  account: {
    disabled: ["nexus"],
  },
  filters: ["sector"],
  trackingGA: trackingId,
};
